import { render, staticRenderFns } from "./TodayData.vue?vue&type=template&id=221b8b7c&scoped=true&"
import script from "./TodayData.vue?vue&type=script&lang=js&"
export * from "./TodayData.vue?vue&type=script&lang=js&"
import style0 from "./TodayData.vue?vue&type=style&index=0&id=221b8b7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221b8b7c",
  null
  
)

export default component.exports